/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as S from './Questionnaire.styled';

export default function JobOffer() {
    const tableName = 'JobOffer';
    const [dataList, setData] = useState<any>();
    const params = useParams();
    const candidate_id = Number(params.id);
    useEffect(() => {
        setData(null);
        api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
    }, [candidate_id]);
    return (
        <>
            <div>
                {dataList?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.Box>
                            <h4>Work Permit</h4>
                            <h4>Employer Permit</h4>
                            <S.Value>{data?.work_permit}</S.Value>
                            <S.Value> {data?.employer_permit}</S.Value>
                            <h4>Country</h4>
                            <h4>Region</h4>
                            <S.Value>{data?.country}</S.Value>
                            <S.Value>{data?.region}</S.Value>
                            <h4>Profession</h4>
                            <h4>Hourly Wage</h4>
                            <S.Value>{data?.profession}</S.Value>
                            <S.Value>
                                {data?.hourly_wage.toLocaleString(navigator.language, {
                                    minimumFractionDigits: 0,
                                })}
                            </S.Value>
                        </S.Box>
                    </span>
                ))}
            </div>
        </>
    );
}
